import { Address } from "../address/address.model";
import { AdvisorData } from "../advisor/advisor.model";

export class StringHelper {
  static phoneFormat(phone: string): string {
    if (!phone)
      return null;

    phone = phone.replace(/\D/g, '');

    if (phone.startsWith('1'))
      phone = phone.substring(1);

    return '(' + phone.substring(0, 3) + ') ' + phone.substring(3, 6) + '-' + phone.substring(6);
  }

  static addressFormat(address: Address): string {
    if (!address) {
      return '';
    }

    let result = `${address.line1 ? address.line1 + ' ' : ''}`;
    if (address.line2) {
      result += `${address?.line2} `;
    }
    result += `${address.city ? address.city + ',' : ''} ${address.state ?? ''} ${address.zip ?? ''}`;

    return result;
  }

  static advisorContactFormat = (advisorData: AdvisorData, withHtmlTags: boolean = true): string => {
    if (!advisorData?.fullName || (!advisorData?.email && !advisorData?.phone)) {
      return ' ';
    }
  
    const advisorEmailFormat = StringHelper.prepareAdvisorEmailFormat(advisorData?.email, withHtmlTags);
    const advisorPhoneFormat = StringHelper.prepareAdvisorPhoneFormat(advisorData?.phone, withHtmlTags);
  
    if (!advisorData?.email) {
      return ` ${advisorData.fullName} at ${advisorPhoneFormat} `;
    }
  
    if (!advisorData?.phone) {
      return ` ${advisorData.fullName} at ${advisorEmailFormat} `;
    }
  
    return ` ${advisorData.fullName} at ${advisorEmailFormat} or ${advisorPhoneFormat} `;
  }
  
  private static prepareAdvisorEmailFormat = (email: string, withHtmlTags: boolean): string => {
    if (!email) {
      return "";
    }
  
    return withHtmlTags ? `<a href="mailto:${email}">${email}</a>` : email;
  }
  
  private static prepareAdvisorPhoneFormat = (phone: string, withHtmlTags: boolean): string => {
    if (!phone) {
      return "";
    }
  
    return withHtmlTags ? `<a href="tel:${phone}">${StringHelper.phoneFormat(phone)}</a>` : StringHelper.phoneFormat(phone);
  }
}
